// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"235":"f11048f7","656":"b8369e35"}[chunkId] + ".css";
};